import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './useAuth'

/**
 * Route guard. Signed-out visitors go to /login?next=<the page they asked
 * for>, and come back there after signing in.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  const location = useLocation()
  if (!user || user.platform_role !== 'super_admin') {
    const here = `${location.pathname}${location.search}${location.hash}`
    const next = here === '/' ? '' : `?next=${encodeURIComponent(here)}`
    return <Navigate to={`/login${next}`} replace />
  }
  return <>{children}</>
}
